/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Favorite(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g
                    id='svg_12'
                    stroke='null'
                >
                    <g
                        fill='none'
                        fillRule='evenodd'
                        id='svg_7'
                        transform='matrix(1.1558005714401582,0,0,1.1642171922357814,4.4235629327088,6.751480766248571) '
                    >
                        <g
                            fill={iconColor || '#C5C3C3'}
                            id='svg_8'
                            stroke='null'
                        >
                            <g
                                id='svg_9'
                                stroke='null'
                            >
                                <path
                                    d='m292.525,301.5c-2.6524,0 -5.196,1.0539 -7.071,2.929c-1.875,1.8751 -2.929,4.4188 -2.929,7.071c0,2.6522 1.0539,5.196 2.929,7.071c1.8751,1.875 4.4188,2.929 7.071,2.929c2.6522,0 5.196,-1.0539 7.071,-2.929c1.875,-1.8751 2.929,-4.4188 2.929,-7.071c0,-2.6522 -1.0539,-5.196 -2.929,-7.071c-1.8751,-1.875 -4.4188,-2.929 -7.071,-2.929zm5.93726,8.81974l-3.22804,2.31408l1.23309,3.74068c0.05781,0.17417 -0.00481,0.36576 -0.15494,0.47342c-0.15092,0.10767 -0.35484,0.10767 -0.50495,-0.00079l-3.22804,-2.31328l-3.22805,2.31328c-0.15012,0.10846 -0.35404,0.10846 -0.50495,0.00079c-0.15012,-0.10767 -0.21275,-0.29926 -0.15494,-0.47342l1.2331,-3.74068l-3.22805,-2.31408c-0.14771,-0.10925 -0.20792,-0.29927 -0.14932,-0.47105c0.05861,-0.17258 0.22157,-0.28897 0.40623,-0.28897l3.98187,0l1.2331,-3.74068c0.05459,-0.18842 0.2296,-0.31904 0.42789,-0.31904c0.19909,0 0.3741,0.13063 0.42868,0.31904l1.2331,3.74068l3.98188,0c0.18384,0 0.34761,0.11638 0.40622,0.28897c0.0578,0.1718 -0.00241,0.36181 -0.14932,0.47105l-0.03456,0z'
                                    id='svg_10'
                                    stroke='null'
                                    transform='translate(-286,-307) '
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}